import get from 'lodash/get';
import * as wpPageActions from './../action_creators/wp_page_action_creators';
import asyncCustomPageActions from './async_custom_page_actions';
import asyncRecircFeedActions, {
  hideRecircAction
} from './async_recirc_feed_actions';
import notFoundActionCreator from '../../redux/action_creators/not_found_status_action_creator';
import log from '../../services/logger_service';

export default function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(wpPageActions.wpPageLoading({}, store));
    return Promise.all([
      asyncCustomPageActions(params, store)(dispatch),
      asyncRecircFeedActions(params, store)(dispatch)
    ])
      .then(function handlePostDetailData() {
        dispatch(wpPageActions.wpPageLoaded({}, store));

        // requester doesn't want recirc to show on apply/brands-that-matter and /best-workplaces-for-innovators
        if (
          get(params, 'params.slug') === 'brands-that-matter' ||
          get(params, 'params.slug') === 'best-workplaces-for-innovators' ||
          get(params, 'params.slug') === 'innovation-by-design' ||
          get(params, 'params.slug') === 'next-big-things-in-tech'
        ) {
          hideRecircAction(dispatch)();
        }

        return true;
      })
      .catch(function handleUserError(err) {
        const status = get(err, 'response.status') || 500;
        if (status === 404) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        } else {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(err, `Error in wp page actions, message: ${err.message}`);
        }
        dispatch(wpPageActions.wpPageLoadError(err, store));
      });
  };
}
